import { Component, inject, OnInit, viewChild } from '@angular/core';
import { idNameItem, jkLib, JkBaseOption, jkRestReturn, MaterialModule, TitlebarComponent, JkJobKind } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, JkBatchComponent } from 'jk-advcom';
import { stklg002List, StklgService, StkmfService } from '../_service_stk';
import {
  kLineTypeList,
  PassthroughParam,
  StockService,
  tradeSessionList,
} from '../services/stock.service';

class Stkpb05Option extends JkBaseOption {
  date1: string;
  date2: string = jkLib.nowDate();
  stklg002: string = '日線';
  groupId: string = '000';
  kLineType: string = '4';
  tradeSession: string = '0';
  calcOneDay: boolean = true;
  calcSTKMJ: boolean = true;
  dateA: string = jkLib.nowDate();
  dateB: string = jkLib.nowDate();
  candleGroupNo: string = '';
  candleType: string = 'EQUITY';
  candleTimeframe: string = 'D';
  candleSymbolList: string = '';
  candleMessage: string = '';

  constructor(name: string) {
    super(name);
    this.date1 = jkLib.countDate(this.date2, 'D', -120);
  }
}

@Component({
  selector: 'app-stkpb05',
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
  templateUrl: './stkpb05.component.html',
  styleUrls: ['./stkpb05.component.scss'],
})
export class Stkpb05Component extends JkBatchComponent implements OnInit {
  override _programId = 'stkpb05';

  readonly titlebar = viewChild.required<TitlebarComponent>('titlebar');
  pageOpt: Stkpb05Option = new Stkpb05Option(this.programId);
  batchAction: string = 'SaveKLineByDate';
  stkmfSrv = inject(StkmfService);
  stockSrv: StockService = new StockService();
  stklgSrv: StklgService = new StklgService();

  batchActionList: idNameItem[] = [
    { id: 'SaveKLineByDate', name: '群益API產生K線資料(日期起訖)' },
    { id: 'CalcOneDay', name: '技術分析重計[calcOneDay](日期起訖)X日期起有誤' },
    { id: 'CalcRange', name: '技術分析區間重計前90天[calcRange]' },
    { id: 'CalcSTKMJ', name: '選股中心重計[calcSTKMJ](日期起訖)' },
    { id: 'CalcRangeAll', name: '技術資料全部重計(calc_range_all)' },
  ];
  kLineTypeList: idNameItem[] = kLineTypeList;
  tradeSessionList: idNameItem[] = tradeSessionList;
  stklg002List: idNameItem[] = stklg002List;
  candleGroupList: idNameItem[] = [];
  candleTypeList: idNameItem[] = [
    { id: 'EQUITY', name: '股票' },
    { id: 'INDEX', name: '指數' },
    { id: 'WARRANT', name: '權證' },
    { id: 'ODDLOT', name: '零股' },
    { id: 'FUTURE', name: '期貨' },
  ];
  candleTimeframeList: idNameItem[] = [
    { id: '1', name: '1分' },
    { id: '5', name: '5分' },
    { id: '10', name: '10分' },
    { id: '15', name: '15分' },
    { id: '30', name: '30分' },
    { id: '60', name: '60分' },
    { id: 'D', name: '日K' },
    { id: 'W', name: '週K' },
    { id: 'M', name: '月K' },
  ];
  isBusy: boolean = false;

  constructor() {
    super();
    this.setFormOpt2('資料維護作業');
    this.syncStockOptions();
    this.logMessage = '無錯誤訊息';
  }

  override async ngOnInit() {
    super.ngOnInit();
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    await this.loadCandleGroupList();
    this.checkAllInit(this);
  }

  ngOnExit() {
  }

  get kLineMinute(): number {
    switch (this.pageOpt.stklg002) {
      case '0001':
        return 1;
      case '0005':
        return 5;
      case '0010':
        return 10;
      case '0015':
        return 15;
      case '0030':
        return 30;
      case '0060':
        return 60;
      default:
        return 0;
    }
  }

  private syncStockOptions() {
    this.stockSrv.date1 = this.pageOpt.date1;
    this.stockSrv.date2 = this.pageOpt.date2;
    this.stockSrv.stklg002 = this.pageOpt.stklg002;
    this.stockSrv.groupId = this.pageOpt.groupId;
  }

  private async getGroupStockString(): Promise<string> {
    let stockNos = await this.stkmfSrv.getGroupStocks(this.pageOpt.groupId, true);
    return stockNos.join(',');
  }

  async doRunSelectedAction() {
    switch (this.batchAction) {
      case 'SaveKLineByDate':
        await this.doSaveKLineByDate();
        break;
      case 'CalcOneDay':
        await this.doCalcOneDay();
        break;
      case 'CalcRange':
        await this.doCalcRange();
        break;
      case 'CalcSTKMJ':
        await this.doCalcSTKMJ();
        break;
      case 'CalcRangeAll':
        await this.doCalcRangeAll();
        break;
      default:
        await this.showAlert('請選擇執行項目');
        break;
    }
  }

  async doSaveKLineByDate() {
    this.syncStockOptions();
    let stocknoStr = await this.getGroupStockString();
    let body: PassthroughParam = {
      prid: 'SaveKLineByDate',
      srvid: 'quote',
      caption: '產生K線資料(日期起訖)',
      date1: this.pageOpt.date1,
      date2: this.pageOpt.date2,
      kLineType: this.pageOpt.kLineType,
      tradeSession: this.pageOpt.tradeSession,
      kLineMinute: this.kLineMinute,
      stocknoStr,
      calcOneDay: this.pageOpt.calcOneDay,
      calcSTKMJ: this.pageOpt.calcSTKMJ,
    };
    await this.doPassThrough(body.prid, body);
  }

  async doPassThrough(prid: string, body: any): Promise<jkRestReturn> {
    body.prid = prid;
    let caption = body.caption;
    let ret: jkRestReturn = await this.stockSrv.passThrough(body);
    if (ret.result) {
      this.showToast(caption + '(' + prid + ') 成功');
    } else {
      await this.showAlert(
        caption +
        '(' +
        prid +
        ') 失敗:' +
        ret.message +
        ' ' +
        ret.getResultError()
      );
    }
    return ret;
  }

  async doCalcOneDay() {
    this.syncStockOptions();
    let stocknoStr = await this.getGroupStockString();
    await this.stklgSrv.doCalcOneday(
      stocknoStr,
      this.pageOpt.date1,
      this.pageOpt.date2,
      this.pageOpt.stklg002,
      this.stockSrv.topN,
      this.ret
    );
    this.doShowJkRestResult(this.ret);
  }

  doCalcSTKMJ() {
    this.syncStockOptions();
    this.stockSrv.calcSTKMJ(
      this.pageOpt.groupId,
      this.pageOpt.date1,
      this.pageOpt.date2,
      this.pageOpt.stklg002,
      '1325',
      ''
    ).subscribe((res: any) => {
      this.logMessage += JSON.stringify(res) + '\n';
      this.cdr.markForCheck();
    });
  }

  async doCalcRangeAll() {
    this.syncStockOptions();
    await this.stockSrv.doCalcRangeAll(true, this.ret);
  }

  async doCalcRange() {
    this.syncStockOptions();
    let stocknoStr = await this.getGroupStockString();
    this.stklgSrv.doCalcRange(
      stocknoStr,
      this.pageOpt.date2,
      this.pageOpt.stklg002,
      90,
      '0000',
      this.ret
    );
    this.showToast('處理中.等待回報');
  }

  private async loadCandleGroupList(): Promise<void> {
    try {
      const sql = `SELECT ME001 AS id, ME002 AS name FROM STKME ORDER BY ME001`;
      this.candleGroupList = await this.orm.simpleSqlPromise(this.login.host, sql, this.ret);
      if (!this.pageOpt.candleGroupNo && this.candleGroupList.length > 0) {
        this.pageOpt.candleGroupNo = this.candleGroupList[0].id;
      }
    } catch (error) {
      this.candleGroupList = [];
      this.pageOpt.candleMessage = JSON.stringify({
        result: false,
        message: '讀取股票群組失敗',
        error: this.toSerializableError(error),
      }, null, 2);
    } finally {
      this.cdr.markForCheck();
    }
  }

  async doAddGroupStocks(): Promise<void> {
    if (!this.pageOpt.candleGroupNo) {
      await this.showAlert('請先選擇股票群組');
      return;
    }
    const groupStocks = await this.stkmfSrv.getGroupStocks(this.pageOpt.candleGroupNo, true);
    const merged = this.parseSymbolList(this.pageOpt.candleSymbolList + ',' + groupStocks.join(','));
    this.pageOpt.candleSymbolList = merged.join(',');
    this.cdr.markForCheck();
  }

  async getCandles(): Promise<void> {
    const symbols = this.parseSymbolList(this.pageOpt.candleSymbolList);
    if (symbols.length === 0) {
      await this.showAlert('請輸入或加入股票代號');
      return;
    }
    const from = this.toApiDate(this.pageOpt.dateA);
    const to = this.toApiDate(this.pageOpt.dateB);
    this.isBusy = true;
    this.pageOpt.candleMessage = '';
    try {
      for (const symbol of symbols) {
        const startedAt = Date.now();
        try {
          const ret = await this.stockSrv.getHistoricalCandles({
            symbolList: symbol,
            isGroupId: false,
            type: this.pageOpt.candleType,
            from,
            to,
            timeframe: this.pageOpt.candleTimeframe,
          });
          const elapsedSeconds = ((Date.now() - startedAt) / 1000).toFixed(1);
          if (ret.result) {
            const count = ret.obj?.totalRecords ?? 0;
            this.pageOpt.candleMessage += `${symbol},${count}筆,${elapsedSeconds}s\n`;
          } else {
            this.pageOpt.candleMessage += `${symbol},失敗:${this.getRetError(ret)},${elapsedSeconds}s\n`;
          }
        } catch (error) {
          const elapsedSeconds = ((Date.now() - startedAt) / 1000).toFixed(1);
          this.pageOpt.candleMessage += `${symbol},失敗:${this.getRequestErrorMessage(error)},${elapsedSeconds}s\n`;
        }
        this.cdr.markForCheck();
      }
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }

  private toApiDate(yyyymmdd: string): string {
    const digits = String(yyyymmdd || '').replace(/\D/g, '');
    if (digits.length !== 8) {
      return yyyymmdd;
    }
    return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
  }

  private parseSymbolList(text: string): string[] {
    const seen = new Set<string>();
    const result: string[] = [];
    const parts = String(text || '').split(/[\s,]+/);
    for (const part of parts) {
      const symbol = part.trim();
      if (symbol === '' || seen.has(symbol)) {
        continue;
      }
      seen.add(symbol);
      result.push(symbol);
    }
    return result;
  }

  private getRetError(ret: jkRestReturn): string {
    const getter = (ret as any).getResultError;
    if (typeof getter === 'function') {
      return getter.call(ret);
    }
    return ret.message || ret.errorLog || '後端未回傳錯誤訊息';
  }

  private getRequestErrorMessage(error: unknown): string {
    const err = error as any;
    const status = err?.response?.status;
    const statusText = err?.response?.statusText;
    const dataMessage = this.getResponseDataMessage(err?.response?.data);
    const message = err?.message ? String(err.message) : '';
    const code = err?.code ? String(err.code) : '';

    if (status) {
      const statusMsg = `HTTP ${status}${statusText ? ' ' + statusText : ''}`;
      return dataMessage ? `${statusMsg}: ${dataMessage}` : `${statusMsg}${message ? ': ' + message : ''}`;
    }

    if (message) {
      return code ? `${message} (${code})` : message;
    }

    return String(error || '後端連線失敗');
  }

  private getResponseDataMessage(data: unknown): string {
    if (!data) {
      return '';
    }

    if (typeof data === 'string') {
      return data;
    }

    const obj = data as any;
    const getter = obj?.getResultError;
    if (typeof getter === 'function') {
      return getter.call(obj);
    }

    return obj?.message || obj?.errorLog || JSON.stringify(data);
  }

  private toSerializableError(error: unknown): any {
    const err = error as any;
    if (!err || typeof err !== 'object') {
      return error;
    }

    return {
      name: err.name,
      message: err.message,
      code: err.code,
      status: err.response?.status,
      statusText: err.response?.statusText,
      url: err.config?.url,
      responseData: err.response?.data,
    };
  }
  async getCandlesGroup(candleGroupNo: string): Promise<void> {
    if (!candleGroupNo) {
      await this.showAlert('請先選擇股票群組');
      return;
    }
    const from = this.toApiDate(this.pageOpt.dateA);
    const to = this.toApiDate(this.pageOpt.dateB);
    this.isBusy = true;
    this.pageOpt.candleMessage = '';
    try {
        const startedAt = Date.now();
        try {
          const ret = await this.stockSrv.getHistoricalCandles({
            symbolList: candleGroupNo,
            isGroupId: true,
            type: this.pageOpt.candleType,
            from,
            to,
            timeframe: this.pageOpt.candleTimeframe,
          });
          const elapsedSeconds = ((Date.now() - startedAt) / 1000).toFixed(1);
          if (ret.result) {
            const count = ret.obj?.totalRecords ?? 0;
            this.pageOpt.candleMessage += `${candleGroupNo},${count}筆,${elapsedSeconds}s\n`;
          } else {
            this.pageOpt.candleMessage += `${candleGroupNo},失敗:${this.getRetError(ret)},${elapsedSeconds}s\n`;
          }
        } catch (error) {
          const elapsedSeconds = ((Date.now() - startedAt) / 1000).toFixed(1);
          this.pageOpt.candleMessage += `${candleGroupNo},失敗:${this.getRequestErrorMessage(error)},${elapsedSeconds}s\n`;
        }
        this.cdr.markForCheck();
      
    } finally {
      this.isBusy = false;
      this.cdr.markForCheck();
    }
  }
  async doBatch(){
    this.job.options = [];
    //xName xCaption xKind xData xType xPs
    this.job.addOption("cboReportType", "報表格式", "TjkComboBox", this.reportType,"", "" );
    this.job.addOption("rgWD002", "日期", "TJKRange", this.pageOpt.date1 + "～" + this.pageOpt.date2, "", "");
    this.job.addOption("msWD014", "員工代號", "TjkMultiSelect", this.pageOpt.groupId, "", "");
    this.ret = await this.job.jobInsert("測試","stkpb05", JkJobKind.Api); //空白 或 3    空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知
    if (this.ret.result) {
      //this.navigateTo('/reportview');
    }
  }   
}
